import type {
  CustomerAdminDetail,
  CustomerListRow,
  KycStatus,
} from "@/modules/customers/domain/types";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type CustomersListParams = {
  q?: string;
  kycStatus?: KycStatus;
  limit?: number;
  offset?: number;
  sortField?: "createdAt" | "name" | "phone";
  sortOrder?: "asc" | "desc";
};

export type CustomersListResult = {
  items: CustomerListRow[];
  total: number;
};

export const customersApi = {
  async list(params: CustomersListParams = {}): Promise<CustomersListResult> {
    const searchParams = new URLSearchParams();
    if (params.q) searchParams.set("q", params.q);
    if (params.kycStatus) searchParams.set("kycStatus", params.kycStatus);
    if (params.limit != null) searchParams.set("limit", String(params.limit));
    if (params.offset != null) searchParams.set("offset", String(params.offset));
    if (params.sortField) searchParams.set("sortField", params.sortField);
    if (params.sortOrder) searchParams.set("sortOrder", params.sortOrder);
    const qs = searchParams.toString();
    return fetcher.get<CustomersListResult>(
      `${config.apiUrl}/customers${qs ? `?${qs}` : ""}`,
    );
  },

  async getDetail(id: string): Promise<CustomerAdminDetail> {
    return fetcher.get<CustomerAdminDetail>(
      `${config.apiUrl}/customers/${encodeURIComponent(id)}`,
    );
  },

  async updateKyc(
    id: string,
    body: { kycStatus: KycStatus },
  ): Promise<{
    ok: true;
    kycStatus: KycStatus;
    kycVerifiedAt: string | null;
    kycDocumentRef: string | null;
  }> {
    return fetcher.patch(`${config.apiUrl}/customers/${encodeURIComponent(id)}/kyc`, body);
  },
};
